export const PRIORITY = ["Routine", "Normal", "Urgent", "Emergency"];
export const ASSET_SOURCE = ["Internal Asset", "Third-Party Asset"];
export const STATUS = ["Draft", "Submitted", "Approved", "Scheduled", "In Progress", "Completed", "Cancelled"];
export const APPROVAL_STATUS = ["Pending", "Approved", "Rejected", "Not Required"];
export const DRIVER_STATUS = ["Active", "Inactive", "Leave"];
export const ASSET_STATUS = ["Available", "Assigned", "Out of Service", "Maintenance", "Inactive"];
export const TRUCK_TYPE = ["1/2 ton", "3/4 ton", "1 ton", "Tractor"];
export const TRAILER_TYPE = ["Flatbed", "Lowboy", "Step Deck", "Dry Van", "Reefer", "Dump Trailer"];
export const CONTRACT_TYPE = ["Lump Sum", "Time & Materials", "Unit Price", "Cost Plus", "Other"];
export const CDL_CLASS = ["A", "B", "C"];
export const YES_NO = ["Yes", "No"];
export const ASSET_CATEGORY = ["Truck", "Trailer"];
export const EIA_REGION_OPTIONS = ["NEW_ENGLAND", "CENTRAL_ATLANTIC", "LOWER_ATLANTIC", "MIDWEST", "GULF_COAST", "ROCKY_MOUNTAIN", "WEST_COAST_EX_CA", "CALIFORNIA"];
export const NMFC_CLASSES = ["50", "55", "60", "65", "70", "77.5", "85", "92.5", "100", "110", "125", "150", "175", "200", "250", "300", "400", "500"];
export const LOAD_LENGTH = ["0-20'", "20-45'", "45'+"];
export const LOAD_WEIGHT = ["Less than 15,000", "Less than 45,000", "45,000+"];
export const STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
export const EIA_REGIONS = ["EAST_COAST","NEW_ENGLAND","CENTRAL_ATLANTIC","LOWER_ATLANTIC","MIDWEST","GULF_COAST","ROCKY_MOUNTAIN","WEST_COAST","CALIFORNIA"];

export const STATUS_STYLES = {
  Draft: "bg-neutral-200 text-neutral-700",
  Submitted: "bg-blue-100 text-blue-700",
  Approved: "bg-emerald-100 text-emerald-700",
  Scheduled: "bg-violet-100 text-violet-700",
  "In Progress": "bg-amber-100 text-amber-800",
  Completed: "bg-neutral-900 text-white",
  Cancelled: "bg-red-100 text-red-700",
  Pending: "bg-amber-100 text-amber-800",
  Rejected: "bg-red-100 text-red-700",
  "Not Required": "bg-neutral-200 text-neutral-600",
  Active: "bg-emerald-100 text-emerald-700",
  Inactive: "bg-neutral-200 text-neutral-600",
  Leave: "bg-amber-100 text-amber-800",
  Available: "bg-emerald-100 text-emerald-700",
  Assigned: "bg-violet-100 text-violet-700",
  "Out of Service": "bg-red-100 text-red-700",
  Maintenance: "bg-amber-100 text-amber-800",
};

export const PRIORITY_STYLES = {
  Routine: "bg-neutral-100 text-neutral-600 border-neutral-300",
  Normal: "bg-blue-50 text-blue-700 border-blue-200",
  Urgent: "bg-amber-50 text-amber-800 border-amber-300",
  Emergency: "bg-red-50 text-red-700 border-red-300",
};
